import axios, { AxiosProgressEvent } from 'axios';

export function getBackendHost(): string {
    if (process.env.NODE_ENV !== 'development') {
        if (process.env.REACT_APP_BACKEND_API_PROTOCOL && process.env.REACT_APP_BACKEND_API_HOST && process.env.REACT_APP_BACKEND_API_PORT) {
            return `${process.env.REACT_APP_BACKEND_API_PROTOCOL}://${process.env.REACT_APP_BACKEND_API_HOST}:${process.env.REACT_APP_BACKEND_API_PORT}`
        } else {
            return window.location.origin
        }
    } else {
        return 'http://localhost:15678'
    }
}

export function getDocumentationHost(): string {
    if (process.env.NODE_ENV !== 'development') {
        if (process.env.REACT_APP_DOCU_URL) {
            return process.env.REACT_APP_DOCU_URL
        } else {
            const parts = window.location.host.split(".");

            let indexToReplace = 0

            // Check if the first element is 'www'
            if (parts[0] === "www" && parts.length > 1) {
                indexToReplace = 1;
            }

            parts[indexToReplace] =  parts[indexToReplace] + "-documentation"

            return `${window.location.protocol}//${parts.join(".")}`;
        }
    } else {
        return 'http://localhost:3000'
    }
}

const host = getBackendHost();

export const API_ROOT = `${host}/api/v1`;

export const get = (url: string, withoutCredentials?: boolean): Promise<Response> => {
    return fetch(`${API_ROOT}/${url}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: withoutCredentials ? 'omit' : 'include',
    });
};

export const download = (url: string, onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void) => {
    return axios({
        url: `${API_ROOT}/${url}`,
        method: "GET",
        responseType: "blob", // important
        onDownloadProgress,
        withCredentials: true
    });
};

export const login = (url: string, auth: string): Promise<Response> => {
    return fetch(`${API_ROOT}/${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Host: host,
            Authorization: auth,
        },
    });
};

export const post = (url: string, body: string = ''): Promise<Response> => {
    return fetch(`${API_ROOT}/${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Host: host,
        },
        credentials: 'include',
        body,
    });
};

export const upload = (url: string, body: FormData, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void) => {
    return axios.post(`${API_ROOT}/${url}`, body, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress,
        withCredentials: true
    });
};

export const patch = (url: string, body: string = ''): Promise<Response> => {
    return fetch(`${API_ROOT}/${url}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            Host: host,
        },
        credentials: 'include',
        body,
    });
};

export const put = (url: string, body: string): Promise<Response> => {
    return fetch(`${API_ROOT}/${url}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Host: host,
        },
        credentials: 'include',
        body,
    });
};

export const remove = (url: string, etag: string = ''): Promise<Response> => {
    return fetch(`${API_ROOT}/${url}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'If-None-Match': etag,
        },
        credentials: 'include',
    });
};
